import { AlertTriangle, Copy } from 'lucide-react';
import { toast } from 'sonner';

const isInAppBrowser = () => {
  const ua = navigator.userAgent || '';
  return (
    /FBAN|FBAV|FB_IAB|Instagram|WhatsApp|Messenger|Line\/|MicroMessenger|Twitter|TikTok|Snapchat/i.test(ua) ||
    (/wv\)/.test(ua) && /Android/i.test(ua))
  );
};

export const InAppBrowserWarning = () => {
  if (!isInAppBrowser()) return null;

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success('Link copied — now paste it into Safari or Chrome');
  };

  return (
    <div
      className="p-3 bg-amber-500/10 border border-amber-500/40 rounded-lg text-amber-500 text-sm"
      data-testid="inapp-browser-warning"
    >
      <div className="flex items-start gap-2">
        <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold">Important: open this page in Safari or Chrome</p>
          <p className="mt-1">
            You appear to be using an app's built-in browser (e.g. WhatsApp). Your bank's security
            check (3D Secure) often fails here, causing your card to be declined.
          </p>
          <button
            type="button"
            onClick={copyLink}
            className="mt-2 underline font-medium flex items-center gap-1"
            data-testid="copy-link-for-browser-btn"
          >
            <Copy className="w-3 h-3" /> Copy this link to open in your browser
          </button>
        </div>
      </div>
    </div>
  );
};

export default InAppBrowserWarning;
